<template>
	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->

		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName">
				<Input type="text" v-model="formInline.deviceNum" placeholder="设备编号/IMEI/MAC" />
			</FormItem>

			<FormItem prop="trackName">
				<Select clearable placeholder="设备类型"  v-model="formInline.deviceType">
				    <Option value="0">全部</Option>
				    <Option value="1">在线</Option>
				    <Option value="2">离线</Option>
				</Select>
			</FormItem>

			<FormItem prop="trackName">
				<Select clearable placeholder="设备状态"  v-model="formInline.deviceStat">
				    <Option value="0">全部</Option>
				    <Option value="1">在线</Option>
				    <Option value="2">离线</Option>
				</Select>	
			</FormItem>
			


			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')">查询</Button>
			</FormItem>
			
			<div style="float: right;">
				<Button  type="primary" @click="show('addDevice')">新建设备</Button>
				<!-- <Button style="float: left;margin-left: 5px;" type="primary" @click="show('addExcel')">批量导入</Button> -->
			</div>
			<div style="float: right;margin-right: 20px;">
				<Button  type="primary" @click="show('addDevice')">导入</Button>
				<!-- <Button style="float: left;margin-left: 5px;" type="primary" @click="show('addExcel')">批量导入</Button> -->
			</div>
			
		</Form>


		
		<Table :row-class-name="rowClassName"  :columns="columns1" :data="data1" size="small"></Table>



		<Page :total="pageTotal" :page-size="pageSize" size="small" :page-size-opts="opts" show-elevator show-sizer
		 @on-change="pageChange" @on-page-size-change="totalPageChange" />


		<Modal v-model="modal11" :title="modal.Title">

			<!--设备安装和设备修改-->
			<Form v-if="modal.type=='addDevice'||modal.type=='update'" ref="DeviceForm" :model="DeviceForm" :rules="DeviceRuler"
			 :label-width="70">
				<FormItem label="设备编号" prop="deviceCode">
					<Input v-model="DeviceForm.deviceCode" placeholder="输入设备编号"></Input>
				</FormItem>

				<FormItem label="设备mac" prop="mac">
					<Input v-model="DeviceForm.mac" placeholder="输入设备mac"></Input>
				</FormItem>

				<FormItem label="设备imei" prop="imei">
					<Input v-model="DeviceForm.imei" placeholder="输入设备imei"></Input>
				</FormItem>

				<FormItem label="出厂时间" prop="manufactureDate">
					<DatePicker format="yyyy-MM-dd HH:mm:ss" type="date" placeholder="设备出厂时间" v-model="DeviceForm.manufactureDate"></DatePicker>
				</FormItem>

			</Form>
			<!--设备批量上传-->
			<Upload ref="upload" v-if="modal.type=='addExcel'" :before-upload="handleUpload" multiple type="drag" action="/gateway/device/Import">
				<div style="padding: 20px 0">
					<Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
					<p>点击上传文件</p>
				</div>
			</Upload>



			<!--设备安装-->
			<Form v-if="modal.type=='install'" ref="InstallForm" :model="InstallForm" :rules="InstallRuler" :label-width="70">
				<FormItem label="设备id" prop="id">
					<Input disabled v-model="InstallForm.id" placeholder="输入设备id"></Input>
				</FormItem>
				<FormItem label="设备编号" prop="deviceCode">
					<Input disabled v-model="InstallForm.deviceCode" placeholder="输入设备编号"></Input>
				</FormItem>
				<FormItem label="设备sim卡号" prop="sim">
					<Input v-model="InstallForm.sim" placeholder="输入设备sim卡号"></Input>
				</FormItem>

				<FormItem label="设备安装地址" prop="addr">
					<Input v-model="InstallForm.addr" placeholder="输入设备安装地址"></Input>
				</FormItem>

				<FormItem label="设备维度" prop="latitude">
					<Input v-model="InstallForm.latitude" placeholder="输入设备维度"></Input>
				</FormItem>

				<FormItem label="设备经度" prop="longitude">
					<Input v-model="InstallForm.longitude" placeholder="输入设备经度"></Input>
				</FormItem>

			</Form>


			<div v-if="modal.type!='addExcel'" slot="footer">
				<Button v-if="modal.type!='install'" type="warning" size="large" @click="modalCancel">重置</Button>
				<Button type="success" size="large" @click="modalOk">确定</Button>
			</div>

			<div v-else slot="footer">
				<div style="font-size: 15px;color: black;" v-if="file !== null&modal.type=='addExcel'">上传文件名: {{ file.name }}
					<Button type="primary" @click="cancelup">取消上传</Button>
					<Button type="primary" @click="upload" :loading="loadingStatus">{{ loadingStatus ? 'Uploading' : '点击确认上传' }}</Button>

				</div>
			</div>
		</Modal>
	</div>


</template>

<script>
	import echarts1 from "../../js/echarts_hot.js";
	import dateFormat from '../../../public/js/comm.js'
	import Qs from 'qs'

	export default {
		data() {
			//自定义表单验证
			const latlng = (rule, value, callback) => {
				var latreg = /^(\-|\+)?([0-8]?\d{1}\.\d{0,6}|90\.0{0,6}|[0-8]?\d{1}|90)$/;

				if (!latreg.test(value)) {
					callback(new Error("请填写正确经纬度格式"));
				} else {
					callback();
				}
			};
			return {

				//文件上传
				file: null,
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				modal: {
					Title: "设备信息添加",
					type: "addDevice"
				},

				DeviceForm: {
					id: '',
					deviceCode: '',
					mac: '',
					imei: '',
					manufactureDate: '',

				},
				InstallForm: {
					sim: '',
					addr: '',
					latitude: '',
					longitude: '',
					deviceCode: ''
				},
				DeviceRuler: {
					deviceCode: [{
						required: true,
						message: '此项不为空',
						trigger: 'blur'
					}],
					mac: [{
							required: true,
							message: '此项不为空',
							trigger: 'blur'
						}

					],
					imei: [{
						required: true,
						message: '此项不为空',
						trigger: 'blur'
					}],
					manufactureDate: [{
						required: true,
						type: 'date',
						message: '请输入时间',
						trigger: 'change'
					}],

				},
				InstallRuler: {
					sim: [{
						required: true,
						message: '此项不为空',
						trigger: 'blur'
					}],
					addr: [{
							required: true,
							message: '此项不为空',
							trigger: 'blur'
						}

					],
					latitude: [{
						required: true,
						validator: latlng,
						trigger: 'blur'
					}],
					longitude: [{
						required: true,
						validator: latlng,
						trigger: 'blur'
					}],

				},

				//分页属性
				pageTotal: 10,
				pageSize: 10,
				opts: [10, 20, 30, 40],
				chectedPage: 1,

				//模态对话框
				modal11: false,
				//路过
				passbyCount: 4,
				//逗留
				stayCount: 6,
				//常驻
				residentCount: 23,


				BreadcrumbList: ['管理', '>>', '设备管理'],

				formInline: {
					deviceNum: '',
					deviceStat: '',
					deviceType:''
				},


				//table标题数据
				columns1: [{
						title: '序号',
						key: 'id',
					}, {
						title: '设备编号',
						key: 'deviceCode',
					},
					{
						title: '设备mac',
						key: 'mac'
					},
					{
						title: 'sim卡号',
						key: 'sim'
					},
					{
						title: '出厂日期',
						key: 'manufactureDate',
						render: (h, params) => {
							return h('div',
								dateFormat.formatDate(new Date(params.row.manufactureDate), 'yyyy-MM-dd hh:mm'),
							)
						}
					},
					{
						title: '设备imei号',
						key: 'imei'
					},
					{
						title: '安装地址',
						key: 'addr'
					},
					{
						title: '纬度',
						key: 'latitude'
					},
					{
						title: '经度',
						key: 'longitude'
					},
					{
						title: '创建日期',
						key: 'create',
						render: (h, params) => {
							return h('div',
								dateFormat.formatDate(new Date(params.row.create), 'yyyy-MM-dd hh:mm'),
							)
						}

					},
					{
						title: '是否在线',
						key: 'status'
					}, {
						title: '操作',
						key: 'action',
						width: 200,
						align: 'center',
						render: (h, params) => {
							return h('div', [
								h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show("update", params.row.id)
										}
									}
								}, '修改'),
								h('Button', {
									props: {
										type: 'error',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show("install", params.row.id)
										}
									}
								}, '安装')

							]);
						}
					}
				],
				data1: []
			};
		},
		created() {
			//this.handleSubmit();
		},
		mounted() {},
		methods: {


			rowClassName: function(row, index) {

				if (index % 2 == 0) {
					return 'demo-table-info-row';

				} else if (index % 2 == 1) {
					return 'demo-table-error-row';
				}
				return '';
			},



			//文件上传
			handleUpload: function(file) {
				this.file = file;
				return false;
			},
			upload: function() {
				this.loadingStatus = true;

				this.$refs.upload.post(this.file);
				this.file = null;
				this.loadingStatus = false;
			},
			cancelup: function() {



				this.file = null;
				this.loadingStatus = false;
			},
			show: function(type, params) {
				switch (type) {
					case "addDevice":
						this.modal.type = "addDevice";
						this.modal.Title = "设备添加";
						break;
					case "addExcel":
						this.modal.type = "addExcel";
						this.modal.Title = "设备批量导入";
						break;
					case "update":
						this.modal.type = "update";
						this.modal.Title = "设备信息修改";
						this.selectDeviceById(params);
						break;
					case "install":
						this.modal.type = "install";
						this.modal.Title = "设备安装";
						this.selectInstallById(params);
						break;
				}
				this.modal11 = true;
			},

			selectDeviceById: function(params) {

				const _this = this;
				let parms = {
					id: params
				}
				_this.$axios.post("/gateway/device/getDeviceById", Qs.stringify(parms), {

				}).then(res => {

					if (res.data.status == 1) {
						res.data.data.manufactureDate = new Date(res.data.data.manufactureDate);
						_this.DeviceForm = res.data.data;
					}
				})

			},
			selectInstallById: function(params) {



				const _this = this;
				let parms = {
					id: params
				}
				_this.$axios.post("/gateway/device/queryInstall", Qs.stringify(parms), {

				}).then(res => {
					console.log(res);
					if (res.data.status == 1) {
						res.data.data.manufactureDate = new Date(res.data.data.manufactureDate);
						_this.InstallForm = res.data.data;
					}
				})

			},

			pageChange: function(a) {
				console.log(a)
				this.chectedPage = a;
				this.handleSubmit();
			},
			totalPageChange: function(a) {
				this.pageSize = a;
				this.handleSubmit();
				console.log(a)
			},
			handleSubmit: function(formName) {
				const _this = this;
				let parms = {
					page: this.chectedPage,
					pageSize: this.pageSize,
					keyword: this.formInline.deviceNum,
					status: 0
				}
				_this.$axios.post("/gateway/device/queryList", Qs.stringify(parms), {

				}).then(res => {

					if (res.data.status == 1) {
						res.data.data.list.map(data => {
							data.create = new Date(data.create);
							data.manufactureDate = new Date(data.manufactureDate);
						});
						_this.data1 = res.data.data.list;
						_this.pageTotal = res.data.data.total;
					}
				})


			},



			modalCancel: function() {
				if (this.modal.type === "install") {
					//this.$refs.InstallForm.resetFields();
				} else if (this.modal.type === "addDevice" || this.modal.type === "update") {
					this.$refs.DeviceForm.resetFields();
				}

			},
			modalOk: function() {
				console.log(this.modal.type);
				switch (this.modal.type) {
					case "addDevice":
						this.addDevice();
						break;
					case "addExcel":
						this.modal.type = "addExcel";
						this.modal.Title = "设备批量导入";
						break;
					case "update":
						this.updateDevice();
						break;
					case "install":
						this.installDevice();
						break;
				}

			},
			addDevice: function() {
				const _this = this;
				_this.$refs.DeviceForm.validate().then(res => {
					if (res) {
						const _this = this;
						let parms = _this.DeviceForm;
						_this.$axios.post("/gateway/device/add", parms, {

						}).then(res => {
							console.log(res);
							if (res.data.status == 1) {
								_this.$Message.success('添加成功');

								_this.modal11 = false;
								_this.handleSubmit();
								_this.modalCancel();

							} else {
								_this.$Message.error('添加失败');
							}
						})
					} else {
						_this.$Message.error('请通过校验后再次提交');
					}
				});
			},
			updateDevice: function() {
				const _this = this;
				_this.$refs.DeviceForm.validate().then(res => {
					if (res) {
						const _this = this;
						let parms = _this.DeviceForm;
						_this.$axios.post("/gateway/device/editDevice", parms, {

						}).then(res => {
							console.log(res);
							if (res.data.status == 1) {
								_this.$Message.success('修改成功');

								_this.modal11 = false;
								_this.handleSubmit();
								_this.modalCancel();

							} else {
								_this.$Message.error('修改失败');
							}
						})
					} else {
						_this.$Message.error('请通过校验后再次提交');
					}
				});
			},
			installDevice: function() {
				const _this = this;
				_this.$refs.InstallForm.validate().then(res => {
					if (res) {
						const _this = this;
						let parms = _this.InstallForm;
						_this.$axios.post("/gateway/device/editInstall", parms, {

						}).then(res => {
							console.log(res);
							if (res.data.status == 1) {
								_this.$Message.success('安装成功');

								_this.modal11 = false;
								_this.handleSubmit();
								_this.modalCancel();

							} else {
								_this.$Message.error('安装失败');
							}
						})
					} else {
						_this.$Message.error('请通过校验后再次安装');
					}
				});
			}

		},

	}
</script>

<style>


	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */
</style>
